import { MovieClip } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';

import { AlarmBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { getMatch2AssetPath } from '../../util/assets';
import { AssetDescription } from '@play-co/timestep-core';

const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/alarm'),
    loadMethod: MovieClip.animationLoader,
  },
});

/*
    alarm block view
*/
export class AlarmBlockView extends Container {
  // fields
  //-------------------------------------------------------------------------
  private _animation: MovieClip;
  private _count = 0;

  // properties
  //-------------------------------------------------------------------------
  public get count(): number {
    return this._count;
  }

  public set count(value: number) {
    // update field
    this._count = Math.min(value, 1);
    const active = this.count === 0;
    this._animation.play(
      `clock_${active ? 'active' : 'inactive'}`,
      null,
      active,
    );
  }

  // init
  //-------------------------------------------------------------------------
  constructor(props: AlarmBlockProps) {
    // create base view
    super();
    this._animation = new MovieClip({
      superview: this.view,
      url: manifest().movieclip.url,
      scale: 0.9,
    });
    blockPositionView(this, props);
    this.y += 1;
  }

  public static assets(): (string | AssetDescription<unknown>)[] {
    return Object.values(manifest());
  }
}
